import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_seller_dashboard_index_data = createAsyncThunk(
    'dashboardIndex/get_seller_dashboard_index_data',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/seller/get-dashboard-index-data`, { withCredentials: true })
            console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_admin_dashboard_index_data = createAsyncThunk(
    'dashboardIndex/get_admin_dashboard_index_data',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/get-dashboard-index-data`, { withCredentials: true })
            console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const export_users_csv = createAsyncThunk(
    'dashboardIndex/export_users_csv',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const response = await api.get(`/admin/export-users-csv`, { 
                withCredentials: true,
                responseType: 'blob'
            })
            
            // Create download link
            const blob = new Blob([response.data], { type: 'text/csv' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = 'users_export.csv'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
            
            return fulfillWithValue({ message: 'Users CSV exported successfully' })
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const export_merchants_csv = createAsyncThunk(
    'dashboardIndex/export_merchants_csv',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const response = await api.get(`/admin/export-merchants-csv`, { 
                withCredentials: true,
                responseType: 'blob'
            })
            
            // Create download link
            const blob = new Blob([response.data], { type: 'text/csv' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = 'merchants_export.csv'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
            
            return fulfillWithValue({ message: 'Merchants CSV exported successfully' })
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const dashboardIndexReducer = createSlice({
    name: 'dashboardIndex',
    initialState: {
        totalSale: 0,
        totalOrder: 0,
        totalProduct: 0,
        totalPendingOrder: 0,
        totalSeller: 0,
        totalUsers: 0,
        totalSubscriptions: 0,
        totalVerifications: 0,
        totalVisits: 0,
        recentOrders: [],
        recentMessage: [],
        loader: false,
        successMessage: "",
        errorMessage: ""
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: {
        [get_seller_dashboard_index_data.fulfilled]: (state, { payload }) => {
            state.totalSale = payload.totalSale
            state.totalOrder = payload.totalOrder
            state.totalProduct = payload.totalProduct
            state.totalPendingOrder = payload.totalPendingOrder
            state.recentOrders = payload.recentOrders
            state.recentMessage = payload.messages
            state.totalVisits = payload.totalVisits
        },
        [get_admin_dashboard_index_data.fulfilled]: (state, { payload }) => {
            state.totalSale = payload.totalSale
            state.totalOrder = payload.totalOrder
            state.totalProduct = payload.totalProduct
            state.totalSeller = payload.totalSeller
            state.totalUsers = payload.totalUsers
            state.totalSubscriptions = payload.totalSubscriptions
            state.totalVerifications = payload.totalVerifications
            state.recentOrders = payload.recentOrders
            state.recentMessage = payload.messages
        },
        [export_users_csv.pending]: (state, _) => {
            state.loader = true
        },
        [export_users_csv.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        },
        [export_users_csv.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error || 'Export failed'
        },
        [export_merchants_csv.pending]: (state, _) => {
            state.loader = true
        },
        [export_merchants_csv.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        },
        [export_merchants_csv.rejected]: (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error || 'Export failed'
        }
    }

})
export const { messageClear } = dashboardIndexReducer.actions
export default dashboardIndexReducer.reducer
